/** Test ids and ordered step keys for the welcome onboarding flow. */
export const ONBOARDING_WELCOME_STEP_TEST_IDS = {
  displayName: 'onboarding-welcome-step-display-name',
  task: 'onboarding-welcome-step-task',
  project: 'onboarding-welcome-step-project',
  subtask: 'onboarding-welcome-step-subtask',
  outro: 'onboarding-welcome-outro',
};

export const ONBOARDING_WELCOME_STEPS = [
  'displayName',
  'task',
  'project',
  'subtask',
];
